import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../../../network/auth";
import axios from "axios";
import { baseUrl } from "../../../../../../network/constants/constants";
import { Col, Row, Spinner } from "react-bootstrap";
import CustomerCancelTable from "./customerCancelTable/customerCancelTable";
import SearchField from "../../../../../customComponent/searchField/searchField";

const CustomerCancelAlert = () => {
  const [loading, setLoading] = useState(false);
  const [customerCancelList, setCustomerCancelList] = useState([]);

  console.log(customerCancelList);
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredCustomer = customerCancelList.filter((booking) =>
    Object.entries(booking).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      }

      if (typeof value === "boolean") {
        const stringValue =
          key === "is_refund_processed"
            ? value
              ? "Refunded"
              : "Not Refunded"
            : "";

        return stringValue.toLowerCase().includes(searchValue.toLowerCase());
      }

      return (
        value &&
        value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );

  const displayCustomer = searchValue ? filteredCustomer : customerCancelList;
  const alertwithIndex = displayCustomer.map((alert, index) => ({
    ...alert,
    displayIndex: index + 1,
  }));
  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchCustomerAlerts = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/booking-cancelled-alerts-by-customer/`, config)
      .then((response) => {
        setCustomerCancelList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Customer Cancelled Alert Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCustomerAlerts();
  }, []);
  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row>
            <Col>
              <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
            </Col>
          </Row>
          <Row>
            <CustomerCancelTable customerCancelList={alertwithIndex} />
          </Row>
        </>
      )}
    </>
  );
};

export default CustomerCancelAlert;
